import { render, staticRenderFns } from "./grantAccess.vue?vue&type=template&id=0e38a962"
import script from "./grantAccess.vue?vue&type=script&lang=js"
export * from "./grantAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports